import {Stack, Typography} from '@mui/material';
import React from 'react';

import {Row, StyledCard} from 'presentation/components';
import {useGetBeneficiaryBankDataQuery} from 'presentation/pages/private/profile/queries/useGetBeneficiaryBankDataQuery';
import {translations} from 'presentation/translations-new';
import {SkeletonData} from 'presentation/components/ChangeData/SkeletonData';

const {title, bank, agency, account, digit} =
	translations['pt-br'].privateFlow.refund.conferencePage.bankInfo;

export const BankInfoCard = () => {
	const {data: bankData, isLoading} = useGetBeneficiaryBankDataQuery();

	if (isLoading) {
		return (
			<Stack gap={2} p={2}>
				<SkeletonData type="bank" />
			</Stack>
		);
	}

	return (
		<Stack spacing={2}>
			<Typography fontWeight={600} variant="subtitle2" color={'text.secondary'}>
				{title}
			</Typography>
			<StyledCard.Container>
				<Row.Simple title={bank} value={bankData!.bank.description} />

				<Row.Compound
					items={[
						{
							title: agency,
							value: bankData!.agency,
						},
						{
							title: digit,
							value: bankData?.agencyDigit || '-',
						},
					]}
				/>

				<Row.Compound
					hiddenDivider
					items={[
						{
							title: account,
							value: bankData!.account,
						},
						{
							title: digit,
							value: bankData?.accountDigit || '-',
						},
					]}
				/>
			</StyledCard.Container>
		</Stack>
	);
};
